import { useAllUserGroups } from "../../UserGroup/useAllUserGroups.ts";
import { useOnboardingLivePdfs } from "./useOnboardingLivePdfs.ts";

export function useUserGroupsMissingOnboardingLivePdf() {
  const { userGroups } = useAllUserGroups();
  const { pdfs } = useOnboardingLivePdfs();
  return userGroups.filter(
    (g) =>
      g.onboardingLiveRequired && !pdfs.some((p) => p.userGroupId === g.id),
  );
}
